import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { EmailLogsModel } from "common/models/page-models/email-logs/email-logs-data-model";
import {
  EmailLogsListingModel,
  EmailLogsParams,
} from "common/models/page-models/email-logs/email-logs-grid-model";
import { GridData, GridModel, GridParams, GridPostParams } from "common/models/utility-models/list-utility.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { GridDataService } from "../../base-data-services/grid-data.service";

@Injectable({
  providedIn: "root",
})
export class EmailLogDataService extends GridDataService<
  EmailLogsListingModel,
  EmailLogsModel
> {

  totalRecords:any
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.emailLogList, http, ss);
  }

  createInstance(): EmailLogsListingModel {
    return new EmailLogsListingModel();
  }

  getDeleteUrl(): string {
    return "";
  }

  override modifyGridPostParams(queryParams) {

    return queryParams;
  }

  getGridParams(param): GridPostParams {
    return new EmailLogsParams();
  }

  override async createGridModel(
    apiRes: any,
    queryParam: GridParams,
    dataParam: string = 'details',
    extraParam: string = ''
  ): Promise<any> {
    return await new Promise<any>((resolve, reject) => {
      
      
      const gridModel = new GridModel<any>();
      const gridData = this.transformDataModel(apiRes, dataParam);
      // gridModel.originalModel = !gridData[dataParam]['result'] ? [] : gridData[dataParam]['result'];
      if (gridData[dataParam] && gridData[dataParam]['result']) {
        gridModel.originalModel = gridData[dataParam]['result'];
      } else if (gridData[dataParam] === undefined) {
        gridModel.originalModel = gridData['detail'] ? gridData['detail'] : [];
      }
      gridModel.filterModel = this.cloneData(gridModel.originalModel);

      let dataExtra;
      dataExtra = !apiRes[extraParam] ? [] : apiRes[extraParam];
      
      if (dataExtra.length > 0) {
        dataExtra = apiRes[extraParam]?.sort((a, b) => b.id - a.id);
      }

      if (extraParam) {
        gridModel.extraData = dataExtra;
      }

      gridModel.pageModel = gridModel.originalModel;
      gridModel.pages = [];
      gridModel.search_text = '';
      
      gridModel.selectedPage = queryParam.currentPage
        ? queryParam.currentPage
        : 1;
      gridModel.recordPerPage = 10;
      if (apiRes[dataParam] && apiRes[dataParam]['totalRecords'] !== undefined) {
        this.totalRecords = apiRes[dataParam]['totalRecords'];
        gridModel.totalRecords = this.totalRecords;  
      } else {
        gridModel.totalRecords = this.totalRecords;  
      }

      const pageData = this.getPageData(
        this.cloneData(gridModel.filterModel),
        gridModel.recordPerPage,
        gridModel.totalRecords,
        queryParam.pageNumber
      );

      gridModel.pageModel = pageData.pageModel;
      gridModel.pages = pageData.pages;
      gridModel.chartsData = this.prepareChartsData(gridModel.originalModel);
      const modifiedGridModel = this.getModifiedGridModel(apiRes, gridModel);
      
      resolve(modifiedGridModel);
    }).catch((error) => {
      // return error;
     
      
      const gridModel = new GridModel<any>();
      gridModel.extraData = queryParam;
      gridModel.originalModel = [];
      gridModel.filterModel = [];
      gridModel.pageModel = [];
      gridModel.pages = [];
      return gridModel;
    });
  }


    override getPageData(
      originalModel,
      recordPerPage,
      totalRecords,
      pageNumber
    ): GridData<any> {
  
      const pageData = new GridData<any>();
      const numberOfPage = Math.ceil(totalRecords / recordPerPage);
      // const data = originalModel.slice(
      //   (pageNumber - 1) * recordPerPage,
      //   recordPerPage * pageNumber
      // );
   //  console.log(data);
      
      pageData.pageModel = originalModel;
      pageData.pages = Array.from({ length: numberOfPage }, (_, idx) => ++idx);
    //  console.log(pageData);
      
      return pageData;
    }
}
